export enum GenderEnum {
  Male = 1,
  Female = 2
}

export const GenderOptions = [
{ id: 1, label: 'Male' },
{ id: 2, label: 'Female' }
];
